import {Input } from "antd";
import React from "react";
import HeaderText from "./HeaderText";
import HeaderModalText from "./HeaderModalText";

function ModalInputField({headerText,onChangeText,name,inputFieldValue,hasError,isRequired}) {

  const asterikSign = () => (
    <h2
      style={{
        color: "red",
        fontSize: "20px",
        marginLeft: "5px",
        height:20
      }}
    >
      {" "}
      *
    </h2>
  );
  
  return (
   

    <div >   
<div style={{display:'flex',alignItems:'center',flexDirection:'row'}}>
<HeaderModalText text={headerText}/>
{isRequired && asterikSign()}
</div>
<div>
    
   <Input
   type="text"
   value={inputFieldValue}
   name={name}
   onChange={onChangeText}
   style={{width:"100%",height:"48px"}}
   status={`${hasError?"error":""}`}
 />

 </div>
    </div>

   
  );
}

export default ModalInputField;

ModalInputField.defaultProps={
  hasError:false
}
